import uniqid from 'uniqid'
import { useLanguage } from '../../contexts/language'
import './Skills.css'

const Skills = () => {
  const { lang, portfolio } = useLanguage()
  const { skills } = portfolio

  if (!skills || !skills.length) return null

  return (
    <section className='section skills' id='skills'>
      <h2 className='section__title'>{lang === 'zh' ? '技能' : 'Skills'}</h2>
      <ul className='skills__list'>
        {skills.map((skill) => (
          <li key={uniqid()} className='skills__list-item btn btn--plain'>
            {skill}
          </li>
        ))}
      </ul>
    </section>
  )
}

export default Skills